import dayjs from "dayjs"

import type { CalendarModalData } from "../../redux/calendar.types.ts"

const SLOT_MINUTES = 15
const DEFAULT_DURATION_MINUTES = 30

export const resolveNewEventSlot = (
  dateStr: string,
  timezone?: string,
  allDay?: boolean
): CalendarModalData => {
  const selectedDay = dayjs.tz(dateStr, timezone)

  // An all-day slot click carries no time of day worth rounding — the form
  // hides Start/End Time entirely once All day is checked.
  if (allDay) {
    const utcDate = dayjs.utc(selectedDay.format("YYYY-MM-DD"))

    return {
      date: utcDate,
      start_at: utcDate,
      end_at: utcDate.endOf("day"),
      all_day: true
    }
  }

  const roundedDate = selectedDay
    .minute(Math.round(selectedDay.minute() / SLOT_MINUTES) * SLOT_MINUTES)
    .second(0)
    .millisecond(0)

  return {
    date: roundedDate,
    start_at: roundedDate,
    end_at: roundedDate.add(DEFAULT_DURATION_MINUTES, "minute")
  }
}
